import { post } from "app/utils/axios/kheti";
import { AdvisoryResponse } from "../models/crop";
import { getCookieValue } from "app/farmer360/utils/helper";

interface Body {
  plan_id: number;
  data_queries: Record<string, unknown>[];
}

const createSubscription = async (body: Body) => {
  const userAuthId = getCookieValue("userAuthId");
  const payload = {
    ...body,
    ...(userAuthId ? { farmer: userAuthId } : {}),
  };

  return await post<AdvisoryResponse>("/advisory/v1/subscription/", payload);
};

export default createSubscription;
